import React from 'react';
import PropTypes from 'prop-types'; 
export default function Note({item}) {
  return <div className="Note pt-1">{item.description}</div>;
}

Note.propTypes = {
  item: PropTypes.object
};
